import { PriceChangeInterface } from "../../../../domain/PriceChangeInterface";

type Action =
  | { type: "set"; resources: PriceChangeInterface[] }
  | { type: "update"; uuid: string }
  | { type: "remove"; uuid: string }
  | { type: "toggle"; uuid: string }
  | { type: "toggleAll" };

export function reducer(resources: PriceChangeInterface[], action: Action) {
  switch (action.type) {
    case "set": {
      return action.resources.map(resource => ({ ...resource, selected: false }));
    }
    case "update": {
      return resources.map(resource =>
        resource.uuid === action.uuid ? { ...resource, status: "processing" } : resource
      );
    }
    case "remove": {
      return resources.filter(resource => resource.uuid !== action.uuid);
    }
    case "toggle": {
      return resources.map(resource =>
        resource.uuid === action.uuid ? { ...resource, selected: !resource.selected } : resource
      );
    }
    case "toggleAll": {
      const allSelected = resources
        .filter(resource => resource.status === "pending")
        .every(resource => resource.selected);

      return resources.map(resource =>
        resource.status === "pending" ? { ...resource, selected: !allSelected } : resource
      );
    }
    default: {
      throw new Error("Unknown action");
    }
  }
}
